export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || "";

export const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH || "";

export const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW || "";
